<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="编辑部位"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="部位名称：" prop="locationName">
          <el-input size="mini" v-model.trim="form.locationName" placeholder="请输入部位名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="其他说明：" class="mr0">
          <el-input size="mini" v-model.trim="form.otherDescription" placeholder="请输入其他说明" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注信息：">
          <el-input size="mini" v-model.trim="form.remark" placeholder="请输入备注信息" clearable></el-input>
        </el-form-item>
        
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
      >确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addLocation } from "@/api/MaintenanceLocation";
export default {
  data() {
    return {
      form: {
        remark: '',
        otherDescription: '',
        locationName: ''
      },
      rules: {
        locationName: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "blur",
          },
        ],
      },
      loadBtn: false,
    };
  },
  props: {
    editData: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.form = { ...this.editData };
  },
  created() {},
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const res = await addLocation(this.form);
          if (res.code === 200) {
            this.$message.success("编辑成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/MaintenanceLocation/components/EditLocation.vue